import React, { useEffect } from 'react'
import { dataColumn, timeColumn } from '../../../components/DataColumn';
import CommonGrid from '../../../components/DataGrid/CommonGrid';
import { useDispatch } from 'react-redux';
import { updateVendorData } from '../../../store/slice/mainToCardSlice';
import { IconButton } from '@mui/material';
import { CheckCircle, Delete, HighlightOffOutlined, PauseCircle } from '@mui/icons-material';
import { usePostGetVendorWFAMutation } from '../../../store/api/vendorApi';
import { useState } from 'react';
import table from '../../../helpers/table';
import { Icon } from '@iconify/react';
import { setStep } from '../../../store/slice/buttonSlice';

const WaitingForApprovals = ({
    prequalificationType,
    businessCategory,
    productService,
    vendorType
}) => {

    const [postWFA, { data, isLoading, error }] = usePostGetVendorWFAMutation();

    useEffect(() => {
        postWFA(
            {
                businessCategoryId: businessCategory,
                productServiceId: productService,
                vendorTypeId: vendorType
            }
        )
    }, [postWFA, businessCategory, productService, vendorType])

    const dynamicKey = 'vendorId'

    // Columns
    const columns = (handleNavigation, handleRowDelete, handleRowApprove, handleRowHold, handleRowReject, handleSendToApprove) => [
        {
            field: 'actions',
            headerName: 'Actions',
            headerAlign: 'center',
            align: 'center',
            width: 150,
            renderCell: params => (
                <>
                    <IconButton onClick={() => { handleRowApprove(params.row.vendorId); }} sx={{ p: 0 }}>
                        <CheckCircle style={{ color: "green", marginRight: 3 }} />
                    </IconButton>
                    <IconButton onClick={() => { handleRowHold(params.row.vendorId); }} sx={{ p: 0 }}>
                        <PauseCircle style={{ color: "#ffeb3b", marginRight: 3 }} />
                    </IconButton>
                    <IconButton onClick={() => { handleRowReject(params.row.vendorId); }} sx={{ p: 0 }} >
                        <HighlightOffOutlined style={{ color: "red", marginRight: 3 }} />
                    </IconButton>
                    <IconButton onClick={() => { handleRowDelete(params.row.vendorId); }} sx={{ p: 0, marginLeft: 0.3 }}>
                        <Delete sx={{ color: 'red' }} />
                    </IconButton>
                    <IconButton onClick={() => {
                        handleNavigation(params.row.vendorId)
                        localStorage.setItem('reviseId', params.row.vendorId)
                        localStorage.setItem("readOnlyData", true)
                        localStorage.removeItem("isAuthentication")
                        dispatch(setStep(0))
                    }}>
                        <Icon icon="icon-park:speed-one" />
                    </IconButton>
                </>

            ),
        },
        dataColumn('vendorId', 'Vendor Id', 70),
        dataColumn('taxId', 'Tax ID', 150),
        dataColumn('statusName', 'Status', 150),
        dataColumn('vendorCode', 'Vendor Code', 150),
        dataColumn('vendorName', 'Vendor', 150),
        dataColumn('businessCategory', 'Business Category', 200),
        dataColumn('productService', 'Product Service', 150),
        dataColumn('country', 'Country', 150),
        dataColumn('companyAddress', 'Company Address', 150),
        dataColumn('reviseNo', 'Revise No', 70, "number"),
        timeColumn('reviseDate', 'Revise Date', 150),
        dataColumn('description', 'Description', 150),
        dataColumn('defaultCurrency', 'Currency', 150),
    ];

    // Update Data
    const dispatch = useDispatch();
    const handleUpdateData = (data) => {
        dispatch(updateVendorData(data));
    };

    const [visibleColumns, setVisibleColumns] = useState(table.generateVisibleFields(columns(), 'vendorWFA'))

    useEffect(() => {
        localStorage.setItem('vendorWFA', JSON.stringify(visibleColumns));
    }, [visibleColumns]);

    return (
        <div>
            <CommonGrid
                columns={columns}
                data={data}
                dynamicKey={dynamicKey}
                isLoading={isLoading}
                error={error}
                setColumnVisibility={setVisibleColumns}
                columnVisibility={visibleColumns}
                handleUpdateData={handleUpdateData}
                height={'50vh'} />
        </div>
    )
}

export default WaitingForApprovals